import React from 'react'
import img1 from './images/imgq.png'


export default function Queryform() {
    return (
        <div className="container text-center">
            <div className="row ">
                <div className="col-sm">
                    <img src={img1} width={450} height={250} alt='Queryimg' />
                </div>
                <div className="col-sm border border-primary border-2 p-2 mt-2">
                    <form className='p-3'>
                        <div className="form-group">
                            <div className='row'>
                                <div className='col-sm mt-2'>
                                    <input type="name" className="form-control" id="exampleInputEmail1" aria-describedby="emailHelp" placeholder="First Name" />
                                </div>
                                <div className='col-sm mt-2'>
                                    <input type="name" className="form-control" id="exampleInputEmail1" aria-describedby="emailHelp" placeholder="Last Name" />
                                </div>
                            </div>
                        </div>

                        <div className="form-group  mt-2">
                            <input type="email" className="form-control" id="exampleInputEmail1" aria-describedby="emailHelp" placeholder="Enter email" />
                        </div>
                        <div className="form-group  mt-2">
                            <input type="tel" className="form-control" id="exampleInputEmail1" aria-describedby="emailHelp" placeholder="WhatsApp / Phone Number" />
                        </div>
                        <div className="form-group  mt-2">
                            <input type="text" className="form-control" id="exampleInputmessage" placeholder="Message" />
                        </div>
                        <small id="emailHelp" className="form-text text-muted  mt-2"><b>We'll never share your info with anyone else.</b></small><br />
                        <button type="submit" className="btn btn-primary  mt-2">Submit</button>
                    </form>
                </div>
            </div>
        </div>
    )
}
